"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_STEDI_JSONATA_ERROR_MESSAGES = exports.CustomStediJsonataError = exports.MappingTimeoutError = exports.MappingRuntimeError = exports.MappingEvaluationError = void 0;
exports.isJsonataEvaluationError = isJsonataEvaluationError;
exports.isJsonataRuntimeError = isJsonataRuntimeError;
const is_1 = __importDefault(require("@sindresorhus/is"));
function isJsonataEvaluationError(err) {
    if (!is_1.default.object(err)) {
        return false;
    }
    return "token" in err && "code" in err && "position" in err;
}
function isJsonataRuntimeError(err) {
    if (!is_1.default.object(err)) {
        return false;
    }
    if (isJsonataEvaluationError(err)) {
        return false;
    }
    return "code" in err && "position" in err;
}
/**
 * This error happens when JSONata evaluation fails due to malformed mapping.
 * For example, JSONata would fail with an "evaluation error" (the error contains the "token" property) if we were to use the following mapping:
 * {
 *   "foo": {
 * }
 */
class MappingEvaluationError extends Error {
    constructor(error) {
        super(error.message);
        this.name = "MappingEvaluationError";
        this.token = error.token;
        this.position = error.position;
        this.code = error.code;
    }
    serialize() {
        return {
            code: this.code,
            message: this.message,
            token: this.token,
            position: this.position,
            name: this.name,
            stack: this.stack,
        };
    }
    static deserialize(err) {
        return new MappingEvaluationError(err);
    }
}
exports.MappingEvaluationError = MappingEvaluationError;
/**
 * The error has to implement the serializer since it crosses the "worker" boundary.
 * If we did not implement the serializer, the error would be converted to a regular "Error" class and loose the information about the code and other properties.
 *
 * As per documentation: https://threads.js.org/usage-advanced#custom-message-serializers
 * "That means you cannot pass functions and if you pass an instance of some class, you will on the other end receive a plain object that’s no longer an instance of that class."
 */
MappingEvaluationError.serializer = {
    deserialize(message, defaultHandler) {
        if (isJsonataEvaluationError(message)) {
            return new MappingEvaluationError(message);
        }
        return defaultHandler(message);
    },
    serialize(thing, defaultHandler) {
        if (isJsonataEvaluationError(thing)) {
            return new MappingEvaluationError(thing).serialize();
        }
        return defaultHandler(thing);
    },
};
/**
 * This error happens when JSONata evaluation fails due to the input data.
 * For example, imagine a mapping where a given key inside the object is derived from the input data.
 * {
 *   fromInputData: "data"
 * }
 *
 * If the input data is the following:
 * {
 *   "fromInputData": ["1", "2"]
 * }
 *
 * The JSONata will fail.
 */
class MappingRuntimeError extends Error {
    constructor(error) {
        super(error.message);
        this.name = "MappingRuntimeError";
        this.code = error.code;
        this.position = error.position;
    }
    serialize() {
        return {
            code: this.code,
            message: this.message,
            position: this.position,
            name: this.name,
            stack: this.stack,
        };
    }
    static deserialize(err) {
        return new MappingEvaluationError(err);
    }
}
exports.MappingRuntimeError = MappingRuntimeError;
/**
 * The error has to implement the serializer since it crosses the "worker" boundary.
 * If we did not implement the serializer, the error would be converted to a regular "Error" class and loose the information about the code and other properties.
 *
 * As per documentation: https://threads.js.org/usage-advanced#custom-message-serializers
 * "That means you cannot pass functions and if you pass an instance of some class, you will on the other end receive a plain object that’s no longer an instance of that class."
 */
MappingRuntimeError.serializer = {
    deserialize(message, defaultHandler) {
        if (isJsonataRuntimeError(message)) {
            return new MappingRuntimeError(message);
        }
        return defaultHandler(message);
    },
    serialize(thing, defaultHandler) {
        if (isJsonataRuntimeError(thing)) {
            return new MappingRuntimeError(thing).serialize();
        }
        return defaultHandler(thing);
    },
};
class MappingTimeoutError extends Error {
    constructor(milliseconds) {
        super(`Failed to map data within ${milliseconds}ms`);
    }
}
exports.MappingTimeoutError = MappingTimeoutError;
var CustomStediJsonataError;
(function (CustomStediJsonataError) {
    CustomStediJsonataError["STEDI001"] = "STEDI001";
    CustomStediJsonataError["STEDI002"] = "STEDI002";
    CustomStediJsonataError["STEDI003"] = "STEDI003";
})(CustomStediJsonataError || (exports.CustomStediJsonataError = CustomStediJsonataError = {}));
exports.CUSTOM_STEDI_JSONATA_ERROR_MESSAGES = {
    [CustomStediJsonataError.STEDI001]: "$convertDateTime returned an error",
    [CustomStediJsonataError.STEDI002]: "$currentDateTime returned an error",
    [CustomStediJsonataError.STEDI003]: "$lookupTable returned an error",
};
